import React from "react";
import styles from "./StudentLoansEduJourney.module.css";
import Image from "next/image";

interface Image {
  id: number;
  title: string;
  image: {
    url: string;
    alternativeText: string;
    documentId: string;
  };
}

interface TileDescription {
  id: number;
  title: string;
  description: string;
}

interface EmpowermentData {
  id: number;
  title_description: TileDescription;
  title_images: Image[];
}

interface Props {
  data: EmpowermentData;
  note: string;
}

const StudentLoansEduJourney: React.FC<Props> = ({ data, note }) => {
  const { title_description, title_images } = data;
  return (
    <div className="container">
      <div className={styles.eduLoans}>
        <h2 className={styles.eduLoansHeader}>{title_description?.title}</h2>
        <p className={styles.eduLoansDescription}>
          {title_description?.description}
        </p>
        <div className={styles.eduLoansStat}>
          {title_images?.map((card) => (
            <div key={card.id}>
              <Image
                src={card?.image?.url}
                alt={card?.image?.alternativeText}
                title={card?.image?.alternativeText}
                width={75}
                height={64}
              />

              <p className={styles.eduLoansLogoname}>{card?.title}</p>
            </div>
          ))}
        </div>
        <div className={styles.eduLoansNote}>
          <span className={styles.eduLoansNoteSpan}>Note: </span>
          {note}
        </div>
      </div>
    </div>
  );
};

export default StudentLoansEduJourney;
